"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledCloseIcon = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useSwipe2 = _interopRequireDefault(require("../../hooks/useSwipe"));
var _useFreezeBody2 = _interopRequireDefault(require("../../hooks/useFreezeBody"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _Close = _interopRequireDefault(require("../../icons-react/Close"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MobilePopupBottom = function MobilePopupBottom(props) {
  var children = props.children,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {
      return null;
    } : _props$onClick,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$options = props.options,
    options = _props$options === void 0 ? {} : _props$options;
  var _options$showCloseBut = options.showCloseButton,
    showCloseButton = _options$showCloseBut === void 0 ? false : _options$showCloseBut,
    _options$showCloseIco = options.showCloseIcon,
    showCloseIcon = _options$showCloseIco === void 0 ? false : _options$showCloseIco,
    _options$showHandleba = options.showHandlebar,
    showHandlebar = _options$showHandleba === void 0 ? false : _options$showHandleba;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHidingAnimationGoing = _useState2[0],
    setIsHidingAnimationGoing = _useState2[1];
  var _useFreezeBody = (0, _useFreezeBody2["default"])(visible),
    setIsFreeze = _useFreezeBody.setIsFreeze;
  var popupRef = (0, _react.useRef)(null);
  var onHide = function onHide() {
    setIsHidingAnimationGoing(true);
    setTimeout(function () {
      onClick();
    }, 300);
  };
  var _useSwipe = (0, _useSwipe2["default"])({
      ref: popupRef,
      onSwipeDown: onHide
    }),
    deltaY = _useSwipe.deltaY,
    resetSwiper = _useSwipe.resetSwiper;
  (0, _react.useEffect)(function () {
    setIsFreeze(visible);
  }, [visible]);
  var onClosePopupClickHandler = function onClosePopupClickHandler(e) {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };
  (0, _react.useEffect)(function () {
    if (visible) {
      resetSwiper();
      setIsHidingAnimationGoing(false);
    }
  }, [visible]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(PopupShadow, {
    onClick: onHide,
    $isAnimationGoing: isHidingAnimationGoing
  }), /*#__PURE__*/_react["default"].createElement(StyledBottomPopup, {
    $isAnimationGoing: isHidingAnimationGoing,
    $delta: deltaY,
    className: className,
    $showHandleBar: showHandlebar,
    ref: popupRef
  }, showCloseIcon && /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, {
    onClick: onClosePopupClickHandler
  }), showHandlebar ? /*#__PURE__*/_react["default"].createElement(HandlebarContainer, null, /*#__PURE__*/_react["default"].createElement(Handlebar, null)) : null, children, showCloseButton ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onTouchEnd: onClosePopupClickHandler
  }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C") : null)));
};
var HandlebarContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__HandlebarContainer",
  componentId: "sc-trbh95-0"
})(["display:flex;justify-content:center;width:100%;padding:8px 0;"]);
var Handlebar = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__Handlebar",
  componentId: "sc-trbh95-1"
})(["width:40px;height:2px;background-color:#c2c5cc;border-radius:2px;"]);
var comingFromBelow = (0, _styledComponents.keyframes)(["from{transform:translateY(50%);}to{transform:translateY(0px);}"]);
var hiding = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;bottom:-200px;}"]);
var StyledBottomPopup = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__StyledBottomPopup",
  componentId: "sc-trbh95-2"
})(["display:flex;max-height:95%;flex-direction:column;background-color:", ";border-radius:4px 4px 0px 0px;padding:", "8px;position:fixed;width:100%;right:0;bottom:-", "px;opacity:1;z-index:4;font-size:12px;line-height:16px;white-space:pre-line;animation:0.25s ", " linear;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var $showHandleBar = _ref2.$showHandleBar;
  return $showHandleBar ? '0 8px 8px' : '';
}, function (_ref3) {
  var $delta = _ref3.$delta;
  return $delta;
}, comingFromBelow, function (_ref4) {
  var $isAnimationGoing = _ref4.$isAnimationGoing;
  return $isAnimationGoing && (0, _styledComponents.css)(["animation:0.4s ", " linear;"], hiding);
});
var slowAppear = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__Container",
  componentId: "sc-trbh95-3"
})(["z-index:11000;position:fixed;height:100vh;width:100%;"]);
var PopupShadow = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__PopupShadow",
  componentId: "sc-trbh95-4"
})(["position:fixed;overflow:hidden;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0.4);height:100vh;animation:0.25s ", " linear;transition:0.3s opacity linear;", ""], slowAppear, function (_ref5) {
  var $isAnimationGoing = _ref5.$isAnimationGoing;
  return $isAnimationGoing && (0, _styledComponents.css)(["opacity:0;"]);
});
var StyledButton = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopupBottom__StyledButton",
  componentId: "sc-trbh95-5"
})(["border:1px solid ", ";color:", ";box-sizing:border-box;border-radius:4px;padding:8px 16px;font-size:14px;line-height:16px;text-align:center;margin-top:12px;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blue;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blue;
});
var StyledCloseIcon = exports.StyledCloseIcon = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "MobilePopupBottom__StyledCloseIcon",
  componentId: "sc-trbh95-6"
})(["position:absolute;right:8px;cursor:pointer;stroke:#4d4d4d;width:15px;height:15px;"]);
var _default = exports["default"] = MobilePopupBottom;